<template>
    <i class="bi-grip-vertical drag-handle-icon"/>
</template>

<style scoped>
.drag-handle-icon {
    cursor: grab;
}

/* Optional: visual feedback when dragging */
.drag-handle-icon:active {
    cursor: grabbing;
}
</style>